const Card = ({ children }) => {
  return <>
      <div className='flex flex-col bg-white items-center space-y-6 p-9 rounded-4xl shadow-xl min-w-[325px] m-6'>
        {children}
      </div>
  </>;
};

export default Card;